/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gyms_Name_ErrorInputs */

const en_us2_gyms_name_error = /** @type {(inputs: Gyms_Name_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give it a name.`)
};

const pt_br2_gyms_name_error = /** @type {(inputs: Gyms_Name_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dê um nome a ela.`)
};

const es_419_gyms_name_error = /** @type {(inputs: Gyms_Name_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponle un nombre.`)
};

const pt_pt2_gyms_name_error = /** @type {(inputs: Gyms_Name_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dá-lhe um nome.`)
};

const fr_fr2_gyms_name_error = /** @type {(inputs: Gyms_Name_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donne-lui un nom.`)
};

const de_de2_gyms_name_error = /** @type {(inputs: Gyms_Name_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib ihm einen Namen.`)
};

const it_it2_gyms_name_error = /** @type {(inputs: Gyms_Name_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dalle un nome.`)
};

/**
* | output |
* | --- |
* | "Give it a name." |
*
* @param {Gyms_Name_ErrorInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gyms_name_error = /** @type {((inputs?: Gyms_Name_ErrorInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_Name_ErrorInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gyms_name_error(inputs)
	if (locale === "es-419") return es_419_gyms_name_error(inputs)
	if (locale === "pt-PT") return pt_pt2_gyms_name_error(inputs)
	if (locale === "fr-FR") return fr_fr2_gyms_name_error(inputs)
	if (locale === "de-DE") return de_de2_gyms_name_error(inputs)
	if (locale === "it-IT") return it_it2_gyms_name_error(inputs)
	return en_us2_gyms_name_error(inputs)
});
export { gyms_name_error as "gyms.name_error" }